/* globalmodule */
/* homemodule */
define( 'components/m12-masthead/m12-masthead-desktop-menu',[
	'jquery',
	'lib/utils'
	 ],

	function ( $, utils ) {

		'use strict';

		var DesktopMenu = function () {

				this.initialized = false;
			},
			_singleton;

		DesktopMenu.prototype.init = function ( $masthead ) {

			if ( !this.initialized ) {

				// cache masthead dom els (have had to look for some classnames due to integration)
				this.$masthead = $masthead;
				this.$myAccountSection = this.$masthead.find( '[data-myaccount-section]' );
				this.$activeSectionNav = this.$masthead.find( '.m12-section-nav--active' );
				this.$menubar = this.$masthead.find( '[data-m12-bar-content]' );
				this.$sections = this.$activeSectionNav.find( '[data-section]' ).add( this.$myAccountSection );
				this.$searchField = this.$masthead.find( '[data-search-field]' );
				this.$subsections = this.$masthead.find( '.m12-subsection' );

				// class names
				this.sectionFocusedClassname = 'm12-section-nav__item--focused';
				this.sectionExpandedClassname = 'm12-section-nav__item--expanded';
				this.activeSubsectionClassname = 'm12-subsection--active';
				this.toggleButtonClassname = 'm12-section__toggle';
				this.toggleButtonOpenClassname = 'm12-section__toggle--open';
				this.subsectionClass = '.m12-subsection';
				this.subsectionActiveClassname = 'm12-subsection--active';
				this.sectionNavItemHoverClassname = 'm12-section-nav__item--hover';

				// methods
				this.configureUI();
				this.polyfills();

				// set initialized flag
				this.initialized = true;
			}

			if (navigator.userAgent.match(/iPad/i) != null) {
				$('.m12-section-nav__link').on('click', function(e) {
					e.preventDefault();
					$(this).trigger('hover');
				});
			};

		};

		DesktopMenu.prototype.polyfills = function () {

			if ( utils.isLessThanIE10() ) {

				var searchLabel = this.$searchField.attr( 'aria-label' );
				this.$searchField.val( searchLabel );
				this.$searchField.on( 'focus', function () {
					if ($( this ).val() === searchLabel) {
						$( this ).val( '' );
					}
				} );
				this.$searchField.on( 'blur', function () {
					if ($( this ).val().replace(/^\s+|\s+$/g,'') === '' ) {
						$( this ).val( searchLabel );
					}
				} );
			}
		};

		DesktopMenu.prototype.configureUI = function () {

			var self = this;

			$.each( this.$sections, function () {

				var $section = $( this ),
					$link = $( this ).find( '[data-section-link]' ).eq( 0 ),
					$toggleButton = $( '<button aria-label="Toggle menu" class="m12-section__toggle"><span class="aria-only">Toggle Menu</span></button>' );

				if ( $link.attr( 'aria-haspopup' ) === 'true' ) {

					$toggleButton.on( 'click', function () {

						var expanded = $link.attr( 'aria-expanded' );
						$section.toggleClass( self.sectionExpandedClassname );
						$link.attr( 'aria-expanded', expanded === 'false' );
						$toggleButton.toggleClass( self.toggleButtonOpenClassname );

					} );

					$toggleButton.on( 'focus', function () {

						$section.addClass( self.sectionFocusedClassname );
					} );

					$( $toggleButton ).insertAfter( $link );
				}

				$link.on( 'focus', function () {
					self.resetSectionNav();
					$section.addClass( self.sectionFocusedClassname );
				} );

				$link.on( 'blur mouseover', function (ev) {

					// don't reset if moving to a section toggle
					if (ev.type === 'blur' && $(ev.relatedTarget).hasClass('m12-section__toggle') ) {
						return;
					}

					self.resetSectionNav();
				} );

			} );


			this.$searchField.on( 'focus', function () {
				self.resetSectionNav();
			} );

		};

		DesktopMenu.prototype.resetSectionNav = function () {

			this.$sections.removeClass( this.sectionFocusedClassname ).removeClass( this.sectionExpandedClassname );

		};

		_singleton = new DesktopMenu();

		return _singleton;
	} );

